// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draggable-button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  z-index: 10000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
}

.draggable-button:hover {
  background-color: #0056b3;
}

.dropdown-menu ul {
  list-style-type: none;
  margin: 0;
  background-color: white;
  padding: 0;
}

.dropdown-menu li {
  padding: 8px 12px;
  border-radius: 30px;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/Components/DraggableButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".draggable-button {\n  padding: 10px 20px;\n  font-size: 16px;\n  border: none;\n  border-radius: 50%;\n  background-color: #007bff;\n  color: white;\n  z-index: 10000;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s;\n}\n\n.draggable-button:hover {\n  background-color: #0056b3;\n}\n\n.dropdown-menu ul {\n  list-style-type: none;\n  margin: 0;\n  background-color: white;\n  padding: 0;\n}\n\n.dropdown-menu li {\n  padding: 8px 12px;\n  border-radius: 30px;\n  cursor: pointer;\n}\n\n.dropdown-menu li:hover {\n  background-color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
